import { useState } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import GulfStudents3 from "../../../Assets/Gulf_Students/Academic_Readiness.webp"
import GulfStudentsData from "../../../Data/Gulf_Students/GulfStudentsData"
import AcademicReadinessData from "../../../Data/Gulf_Students/Services_Data/AcademicReadinessData"
import AcademicReadinessTestimonialData from "../../../Data/Gulf_Students/Testimonial_Data/AcademicReadinessTestimonialData"
import "../../CSS/GulfStudentsCSS.css"
import "../../CSS/GulfStudentsForm.css"
import TestimonialCard from "../TestimonialCard"

const AcademicReadiness = () => {
    const navigate = useNavigate();
    const [stuName, setStuName] = useState();
    const [email, setEmail] = useState();
    const [intake, setIntake] = useState();
    const [origin, setOrigin] = useState();
    const [destination, setDestination] = useState();
    const [university, setUniversity] = useState();
    const handleSubmit = (e) => {
        if (!stuName || !email || !intake || !origin || !destination || !university) {
            alert("Please Fill all the details before submitting the form.");
            return;
        }
        e.preventDefault();
        // const form = document.getElementById('academic-readiness-form');
        const form = e.target;
        const data = new FormData(form);

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(data).toString(),
        })
            .then(() => {
                setStuName('');
                setEmail('');
                setIntake('');
                setOrigin('');
                setDestination('');
                setUniversity('');
                navigate('/academic-readiness-success');
            })
            .catch((error) => console.log(error));
    };
    return (
        <>
            <Helmet>
                <title>Holistic Learning : Academic Readiness Bootcamp</title>
                <meta name="description" content="Join our free 14-Day Academic Bootcamp for Gulf students. Build study skills before you arrive." />
                <link rel="canonical" href="https://holisitclearning.com/gulf-students/academic-readiness" />
            </Helmet>
            <section className="pre-departure-gulf-students-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-between">
                        <div className="col-md-6 pre-departure-gulf-students-heading-and-para-div">
                            <div className="pre-departure-gulf-students-heading-and-para-first-inner-div">
                                <h2><span>Academic Readiness</span> Bootcamp</h2>
                                <p>Studying abroad means adapting to new classrooms, expectations, and learning styles. Our 14-Day Email Bootcamp helps Gulf students build academic confidence before they arrive—covering time management, study skills, writing norms, and classroom culture. Whether you're headed to the U.S., UK, Canada, or Australia, this free resource gives you the tools to thrive from day one.</p>
                            </div>
                        </div>
                        <div className="col-md-6 pre-departure-gulf-students-image-div">
                            <img src={GulfStudents3} alt="" className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
            <section className="leaving-your-abroad-soon-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-start">
                        <div className="col-md-12 leaving-your-abroad-soon-heading-div">
                            <h2><span>Worried About</span> Your Classroom Expectations?</h2>
                            <h4>This 14-day email course helps Gulf students master study skills, writing norms, and academic confidence. What you'll learn:</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section className="planning-to-study-abroad-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 row-cols-xl-5">
                            {
                                AcademicReadinessData.map((item) => {
                                    return (
                                        <div className="col planning-to-study-abroad-card-div" key={item.id}>
                                            <div className="gulf-student-card-inner-div">
                                                <div className="what-we-offer-card-icon">
                                                    <img src={item.bannerImg} alt="" />
                                                </div>
                                                <p>{item.text}</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </section>
            <section className="contact-now-access-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 contact-now-access-heading-div">
                            <h2>Join the <span>Bootcamp</span></h2>
                        </div>
                        <div className="col-md-6 contact-now-form">
                            <form name="academic-readiness-form" id="/academic-readiness-form" method="post" action="academic-readiness-success" enctype="multipart/form-data" netlify-honeypot="bot-field" data-netlify-recaptcha="true" data-netlify="true" onSubmit={handleSubmit}>
                                <input type="hidden" name="form-name" value="academic-readiness-form" />
                                <div className="row justify-content-center">
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input type="text" className="form-control" id="name" name='name' value={stuName} onChange={(e) => setStuName(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" className="form-control" id="email" name='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="intake" className="form-label">Intake Term</label>
                                        <input type="text" className="form-control" id="intake" name='intake' value={intake} onChange={(e) => setIntake(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="origin" className="form-label">Origin Country</label>
                                        <input type="text" className="form-control" id="origin" name='origin' value={origin} onChange={(e) => setOrigin(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="departure" className="form-label">Destination Country</label>
                                        <input type="text" className="form-control" id="departure" name='departure' value={destination} onChange={(e) => setDestination(e.target.value)} />
                                    </div>
                                    <div className="col-md-6 mb-3 gulf-students-services-form-div">
                                        <label htmlFor="university" className="form-label">Intended University</label>
                                        <input type="text" className="form-control" id="university" name='university' value={university} onChange={(e) => setUniversity(e.target.value)} />
                                    </div>
                                    <div className="col-md-12 mb-3 gulf-students-services-button-div">
                                        <button type="submit">Start My Prep</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-6 curriculum-div">
                            <h3>Curriculum</h3>
                            <p>Day 1: U.S. classroom norms</p>
                            <p>Day 2: Time management strategies</p>
                            <p>Day 3: Academic writing tips</p>
                            <p>…up to Day 14: Career planning & next steps</p>
                            <p className="bootcamp-para">Fill the form for the bootcamp</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="other-services-section-start-here">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-12 other-services-heading-div">
                            <h2>Other <span>Services</span></h2>
                        </div>
                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        {
                            GulfStudentsData.filter(item => item.id !== 2)
                                .map((item) => {
                                    return (
                                        <div className="col our-services-card-div" key={item.id}>
                                            <div className="our-services-card-inner-div">
                                                <div className="what-we-offer-card-icon">
                                                    <img src={item.bannerImg} alt="" />
                                                </div>
                                                <h5>{item.heading}</h5>
                                                <p>{item.text}</p>
                                                {item.link}
                                            </div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </section>
            <TestimonialCard data={AcademicReadinessTestimonialData} title={<><span>Social</span> Proof</>} />
        </>
    )
}

export default AcademicReadiness